import { httpAchievementDatePage, httpCompanyList, httpDictServ } from '@/services/customerServices'
import { Dispatch, SetStateAction } from 'react'
import dayjs from 'dayjs'

/**
 * 表格统一请求
 * @param values - 表单数据
 * @returns
 */
export const fetchList = (values: any) => {
  return new Promise((resolve, reject) => {
    try {
      const { current, pageSize, query } = values
      const params = {
        pageId: current,
        pageSize: pageSize,
      }
      const bodyData = {
        orderBys: [
          {
            columnName: 'id',
            asc: false,
          },
        ],
        year: query.year ? dayjs(query.year).format('YYYY') : '',
        month: query.month ? dayjs(query.month).format('MM') : '',
      }
      httpAchievementDatePage(params, bodyData).then(data => resolve(data))
    } catch {
      reject({ success: false })
    }
  })
}

/**
 * 获取类型下拉数据集合
 * @param setTypes
 */
export const fetchTypes = async (setTypes: Dispatch<SetStateAction<any>>) => {
  try {
    const typeList: any = await httpDictServ({ parentKey: 'performanceType', enable: 1 })
    setTypes(typeList)
  } catch (error) {
    console.log('error', error)
  }
}

/**
 * 获取公司列表
 * @param setCompany
 */
export const fetchCompany = async (setCompany: Dispatch<SetStateAction<any>>) => {
  let companyList: any = await httpCompanyList()
  setCompany(companyList)
}
